import { render, staticRenderFns } from "./DynamicItem.vue?vue&type=template&id=67105414&"
import script from "./DynamicItem.vue?vue&type=script&lang=js&"
export * from "./DynamicItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports